<template>
  <div>
    <custom-dialog
      :title="model.title"
      width="1300px"
      :visible="visible"
      :append-to-body="true"
      v-on="$listeners"
      class="portal-refund-record-dialog"
    >
      <div class="dialog-body">
        <!-- 合同订单信息 -->
        <bill-container
          :title="$t('refund_record_dialog.htddxx')"
          style="padding-bottom: 16px;"
        >
          <custom-table
            index
            :data="orderViewList"
            tableCode="portal_refund_record_order"
            :filterArr="model.type === 'watch' ? ['action'] : []"
            :slots="['totalTerm', 'termUseTime', 'action']"
          >
            <template
              slot="totalTerm"
              slot-scope="scope"
            >
              <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
            </template>
            <template
              slot="termUseTime"
              slot-scope="scope"
            >
              <div>{{ scope.row.termUseTime }}{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</div>
            </template>
            <template
              slot="action"
              slot-scope="scope"
            >
              <el-button
                type="text"
                size="mini"
                @click="onDelRefund(scope.row)"
                :disabled="orderViewList.length === 1"
              >{{ $t('Common.com_delete') }}</el-button>
            </template>
          </custom-table>
        </bill-container>
        <!-- 申请退款方式 -->
        <div style="padding: 16px 6px">
          <el-form
            :model="form"
            ref="form"
          >
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  :label="$t('refund_record_dialog.sqtkfs')"
                  prop="refundMethod"
                  class="is-required"
                >
                  <custom-select
                    v-model="form.refundMethod"
                    :disabled="!!tradeBoList.length || model.type === 'watch'"
                    code="refund_method"
                  ></custom-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- 付款信息 -->
        <bill-container
          :title="$t('refund_record_dialog.tui_kuan_xin_xi')"
          v-if="form.refundMethod && form.refundMethod != 22"
        >
          <payment-msg-bill
            ref="msgBill"
            :auth="model.type === 'watch' ? [] : form.refundMethod == 1 ? ['relativeFlow', 'total', 'addPayMsg', 'edit', 'del'] : ['total', 'addPayMsg', 'edit', 'del']"
            tableCode="portal_payment_msg_bill2"
            v-model="tradeBoList"
            :outerItem="firstOrderItem"
            :balance="registerMsg.balance"
            :deposit="registerMsg.deposit"
            :orderNum="getPaymentCode(registerMsg)"
            :billType="firstOrderItem.billType"
            :payableTotal="totalBreakAmount"
            :tradeMethod="form.refundMethod"
            @success="updateBankFlow"
          ></payment-msg-bill>
        </bill-container>
        <!-- 银行流水信息 -->
        <bill-container
          :title="$t('refund_record_dialog.yhlsxx')"
          v-if="form.refundMethod && form.refundMethod != 22 && form.refundMethod != 50"
        >
          <bank-flow-bill
            v-model="tradeSellerBos"
            :auth="model.type === 'watch' ? ['billFlowSum', 'cashSum', 'rentRest', 'confirmReceive', 'actualReceive', 'addRest', 'restRentAmount', 'total'] : null"
            @del="onDelBankFlow"
          ></bank-flow-bill>
        </bill-container>
        <!-- 退款信息 -->
        <bill-container
          :title="$t('refund_record_dialog.tui_kuan_xin_xi')"
          v-if="form.refundMethod && form.refundMethod == 22"
        >
          <el-row class="item-title-info">
            <el-col
              :span="24"
              v-if="model.type === 'watch'"
            >
              <span class="label">{{ $t('refund_record_dialog.jiao_yi_ri_qi') }}</span>
              <span class="value">{{ balanceRecord.gmtCreate }}</span>
            </el-col>
            <el-col :span="24">
              <span class="label">{{ $t('refund_record_dialog.shou_kuan_gong_si') }}</span>
              <span class="value">{{ firstOrderItem.payableOrgName }}</span>
            </el-col>
            <el-col :span="24">
              <span class="label">{{ $t('refund_record_dialog.ben_ci_zhuan_ru_yu_e') }}</span>
              <span class="value">￥{{ model.type === 'watch' ? balanceRecord.changeAmount : totalBreakAmount }}</span>
            </el-col>
            <el-col
              :span="24"
              v-if="model.type !== 'watch'"
            >
              <span class="label">{{ $t('refund_record_dialog.dqzlye') }}</span>
              <span class="value">￥{{ (partnerBalance.balanceAmount || 0) - (partnerBalance.lockAmount || 0 ) }}</span>
            </el-col>
            <el-col :span="24">
              <span class="label">{{ $t('refund_record_dialog.zrhkyzlye') }}</span>
              <span class="value">￥{{ model.type === 'watch' ? balanceRecord.currentAmount : totalBreakAmount + (partnerBalance.balanceAmount || 0) - (partnerBalance.lockAmount || 0 ) }}</span>
            </el-col>
          </el-row>
        </bill-container>
      </div>
      <div
        class="dialog-footer"
        slot="footer"
      >
        <el-button
          @click="visible = false"
          v-if="model.type !== 'watch'"
        >{{ $t('Common.com_cancel') }}</el-button>
        <el-button
          @click="onStore"
          v-if="model.type !== 'watch'"
          type="primary"
        >{{ $t('refund_record_dialog.zan_cun') }}</el-button>
        <el-button
          @click="onConfirm"
          v-if="model.type !== 'watch'"
          type="primary"
        >{{ $t('Common.com_confirm') }}</el-button>
        <el-button
          @click="visible = false"
          v-if="model.type === 'watch'"
          type="primary"
        >{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import billContainer from './bill_container';
import paymentMsgBill from './payment_msg_bill';
import bankFlowBill from './bank_flow_bill.vue';

export default {
  mixins: [dialogMixins],
  components: {
    billContainer,
    paymentMsgBill,
    bankFlowBill
  },
  data() {
    return {
      provide: true,
      dialogVisible: false,
      dialogModel: {},
      form: {
        refundMethod: ''
      },
      // 应收款账单列表
      orderViewList: [],
      // 结余明细/余额记录
      partnerBalance: {},
      balanceRecord: {},
      // 收款信息
      tradeBoList: [],
      // 收款信息（附加信息）
      registerMsg: {
        balance: 0,
        deposit: 0,
        billPaymentCode: ''
      },
      // 银行流水
      tradeSellerBos: [],
      // 选中行
      firstOrderItem: {},
      refundBo: {}
    };
  },
  computed: {
    // 应退金额
    totalBreakAmount() {
      return this.orderViewList.reduce((pre, item) => pre + Number.parseInt(item.refundFee || 0, 10), 0);
    }
  },
  mounted() {
    this.firstOrderItem = this.model.row;
    this.getDetail();
  },
  methods: {
    /**
     * 获取fms模块balance值
     * @param {object} data 账单详情接口返回的数据
     * @return {number} ret
     */
    getBalance(data) {
      const billPayment = data.billPayment || {
        totalPaymentAmount: 0,
        totalTradeAmount: 0,
        tradeState: 1
      };
      const partnerBalance = data.partnerBalance || {
        balanceAmount: 0,
        lockAmount: 0
      };
      const totalPaymentAmount = billPayment.totalPaymentAmount || 0;
      const totalTradeAmount = billPayment.totalTradeAmount || 0;
      const tradeState = billPayment.tradeState || 1;
      const balanceAmount = partnerBalance.balanceAmount || 0;
      const lockAmount = partnerBalance.lockAmount || 0;
      if (tradeState === 1) {
        return balanceAmount - lockAmount;
      }
      return totalPaymentAmount - totalTradeAmount >= 0 ? balanceAmount - lockAmount + totalPaymentAmount - totalTradeAmount : balanceAmount - lockAmount;
    },
    // 获取详情
    getDetail: function () {
      // const isDeposit = this.model.row.billType === 11;
      const reqUrl = apis.paymentPaymentInfo;
      const billId = this.model.row.refundBillId || this.model.row.billId;
      this.$getJSON(`${reqUrl}/${billId}`).then((res) => {
        const data = res.data || {};
        const billPayment = data.billPayment || {};
        // 付款信息（附加信息）
        this.registerMsg.balance = this.getBalance(data);
        this.registerMsg.deposit = data.deposit || 0;
        this.registerMsg.billPaymentCode = this.getPaymentCode(data);
        this.refundBo = data.refundBo || {};

        this.form.refundMethod = billPayment.refundMethod || data.tradeMethod;

        // // 押金退款
        // if (isDeposit) {
        //   // 退款方式
        //   if (this.refundBo.refundMethod) {
        //     this.form.refundMethod = `${this.refundBo.refundMethod}`;
        //   }
        // } else {
        //   if (data.tradeMethod) {
        //     this.form.refundMethod = `${data.tradeMethod}`;
        //   }
        // }

        // 应退押金明细
        if (data.orderViewList && data.orderViewList.length) {
          this.orderViewList = data.orderViewList;
        } else {
          this.orderViewList = [this.model.row];
        }
        // 付款信息
        if (data.tradeBoList && data.tradeBoList.length) {
          data.tradeBoList.forEach((item) => {
            item.attachs = [];
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              item.attachs = imgRes.data;
            });
          });
          this.tradeBoList = data.tradeBoList;
        }
        // 银行流水
        if (data.tradeSellerBos && data.tradeSellerBos.length) {
          this.tradeSellerBos = data.tradeSellerBos;
        }
        // 余额信息
        this.partnerBalance = data.partnerBalance || {};
        this.balanceRecord = data.balanceRecordList ? data.balanceRecordList[0] || {} : {};
      });
    },
    // 添加应退账款
    onAddRefund: function () {
      this.dialogModel.title = this.$t('refund_record_dialog.tjytzk');
      this.dialogModel.existBillIds = this.orderViewList.map(t => t.billId);
      this.dialogModel.receivableOrgId = this.orderViewList[0].receivableOrgId;
      this.dialogVisible = true;
    },
    // 添加应退账款成功
    onAddRefundSuccess: function (list) {
      this.orderViewList = [...this.orderViewList, ...list];
    },
    // 删除退款账单
    onDelRefund: function (row) {
      this.orderViewList = this.orderViewList.filter(t => row.billId !== t.billId);
    },
    // 暂存
    onStore() {
      const billIdList = this.orderViewList.map(t => t.billId);
      this.$postJSON(apis.billOrderRefundRentSave, {
        billIdList: billIdList,
        billPaymentCode: this.getPaymentCode(this.registerMsg),
        isSubmit: false,
        refundMethod: this.form.refundMethod,
        refundTrade: this.tradeBoList
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success')
        });
        this.$emit('success');
      });
    },
    // 确认保存
    onConfirm: function () {
      const billIdList = this.orderViewList.map(t => t.billId);
      this.$postJSON(apis.billOrderRefundRentSave, {
        billIdList: billIdList,
        billPaymentCode: this.getPaymentCode(this.registerMsg),
        isSubmit: true,
        refundMethod: this.form.refundMethod,
        refundTrade: this.tradeBoList
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success')
        });
        this.$emit('success');
      });
    },
    // 删除银行流水（银行流水信息）
    onDelBankFlow(index) {
      this.$showConfirm(this, this.$t('refund_record_dialog.nqdyscxzdyhlsm')).then(() => {
        const curBankFlow = this.tradeSellerBos[index];
        this.$postJSON(`${apis.billPaymentBankFlowDelete}/${curBankFlow.sellerTradeCode}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success')
          });
          this.tradeBoList.forEach((item) => {
            if (item.sellerTradeCode === curBankFlow.sellerTradeCode) {
              item.sellerTradeCode = null;
            }
          });
          this.tradeSellerBos.splice(index, 1);
        });
      });
    },
    // 更新银行流水(付款信息)
    updateBankFlow(sellerTrade, isLocal) {
      // 本地
      if (isLocal && sellerTrade) {
        if (sellerTrade.type === 'delete') {
          this.tradeSellerBos = this.tradeSellerBos.filter(t => `${t.sellerTradeCode}` !== `${sellerTrade.sellerTradeCode}`);
        } else {
          this.tradeSellerBos = [...this.tradeSellerBos, sellerTrade];
        }
        return;
      }
      const billPaymentCode = this.getPaymentCode(this.registerMsg);
      this.$getJSON(`${apis.billPaymentBankFlowList}/${billPaymentCode}`).then((res) => {
        this.tradeSellerBos = res.data;
      });
    }
  }
};
</script>

<style lang="scss">
.portal-refund-record-dialog {
  .item-title-info {
    line-height: 30px;
    padding: 30px 0;
  }
}
</style>
